<script>
import axios from 'axios';
import swal from 'sweetalert';

export default {
  props: {
    slug: String,
  },

  data: () => ({
    form: {
      name: '',
      email: '',
      telephone: '',
      mobile: '',
      city: '',
      region: '',
      street: '',
      streetNumber: '',
      postcode: '',
      order: '',
      notes: '',
    },
    isSaving: false,
  }),

  computed: {
    isRequired() {
      return this.form.telephone === '' && this.form.mobile === '';
    },
  },

  methods: {
    onInputMobile(formattedNumber, { number, isValid }) {
      if (number.input && !isValid) {
        this.errors.add({
          field: 'mobile-invalid',
          msg: 'Wrong mobile',
        });
      } else {
        this.errors.remove('mobile-invalid');
      }
    },

    onInputTelephone(formattedNumber, { number, isValid }) {
      if (number.input && !isValid) {
        this.errors.remove('telephone-invalid');
        this.errors.add({
          field: 'telephone-invalid',
          msg: 'Wrong mobile',
        });
      } else {
        this.errors.remove('telephone-invalid');
      }
    },

    async handleSubmit() {
      const isValid = await this.$validator.validateAll();

      if (!isValid || this.errors.count()) {
        throw new Error('Εισάγετε έγκυρα στοιχεία!!');
      }

      try {
        this.isSaving = true;

        await axios.post(`/api/shops/${this.slug}`, this.form);

        swal({
          title: 'Ευχαριστούμε!',
          text: 'Η παραγγελία σας έχει καταχωρηθεί επιτυχώς',
          icon: 'success',
          timer: 5000,
          button: {
            text: 'Επιστροφή',
            className:
              'px-4 py-2 rounded shadow text-white bg-blue-600 hover:bg-blue-500 focus:bg-blue-700 font-bold',
          },
        });
      } catch (err) {
        swal({
          title: 'Κάτι πήγε λάθος!',
          text: 'Παρακαλώ προσπαθήστε ξανα',
          icon: 'error',
          timer: 3000,
          button: {
            text: 'Επιστροφή',
            className:
              'px-4 py-2 rounded shadow text-white bg-red-600 hover:bg-red-500 focus:bg-red-700 font-bold',
          },
        });
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
button[type='submit'] {
  min-width: 14rem;
}

:deep() {
  .vue-tel-input {
    border: solid 2px #e2e8f0;
    height: 44px;

    &:focus-within {
      background-color: #ffffff;
      box-shadow: none;
      border-color: #e2e8f0;
    }

    input {
      background-color: #edf2f7;
      &:focus {
        background-color: #ffffff;
      }
    }
  }
}

/*spinner*/
.lds-ring {
  display: inline-block;
  position: relative;
  width: 26px;
  height: 24px;

  div {
    animation: spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border: 3px solid #fff;
    border-color: #fff transparent transparent transparent;
    border-radius: 50%;
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 21px;
    height: 21px;
    margin: 0;

    &:nth-child(1) {
      animation-delay: -0.45s;
    }

    &:nth-child(2) {
      animation-delay: -0.3s;
    }

    &:nth-child(3) {
      animation-delay: -0.15s;
    }
  }
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
